// extracted by mini-css-extract-plugin
module.exports = {"moreLink":"MoreLink_moreLink__MI827","arrow":"MoreLink_arrow__U9LQ4"};